import { Children, isValidElement, ReactElement, useMemo } from 'react';

import { GroupBase, MenuListProps } from 'react-select';

import { Group } from 'components/select/shared';
import { flattenChildren } from 'components/select/virtual/utilities';

export const useConfiguration = <Option, IsMulti extends boolean, Group extends GroupBase<Option>>({
  children,
}: Pick<MenuListProps<Option, IsMulti, Group>, 'children'>) => {
  const flattenedChildren: ReactElement[] = useMemo(() => {
    const flatten = Children.toArray(children);
    const first = (flatten[0] || {}) as ReactElement;

    if (isValidElement(first)) {
      if (first.type === Group) {
        return flattenChildren(flatten);
      }

      return flatten;
    }

    return [];
  }, [children]);

  return {
    estimatedSize: 40,
    flattenedChildren,
  };
};
